import { render, staticRenderFns } from "./BuscadorNav.vue?vue&type=template&id=8545f648"
import script from "./BuscadorNav.vue?vue&type=script&lang=js"
export * from "./BuscadorNav.vue?vue&type=script&lang=js"
import style0 from "./BuscadorNav.vue?vue&type=style&index=0&id=8545f648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports